import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'text-input',
  templateUrl: 'text-input.html'
})
export class TextInput {

  @Input() label: string;
  @Input() value: string;
  @Output() valueChange: any = new EventEmitter();

  updateValue(value: string) {
    this.value = value;
    this.valueChange.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/components/text-input/text-input.component.ts